import { useSyncExternalStore } from "react";
import { authStore, type CurrentUser } from "@/lib/auth";

interface AuthState {
  isAuthenticated: boolean;
  user: CurrentUser | null;
}

function getSnapshot(): AuthState {
  return {
    isAuthenticated: authStore.isAuthenticated(),
    user: authStore.getUser(),
  };
}

let cachedSnapshot: AuthState = getSnapshot();

function subscribe(cb: () => void): () => void {
  return authStore.subscribe(() => {
    cachedSnapshot = getSnapshot();
    cb();
  });
}

export function useAuth(): AuthState {
  return useSyncExternalStore(
    subscribe,
    () => cachedSnapshot,
    () => cachedSnapshot
  );
}
